import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { trackPriceQuoteRequest } from '../../util/mixpanel';

// Import Style
import './SubscribeEDAddOn.scss';

class SubscribeEDAddOn extends Component {
  static defaultProps = {
    user: {}
  };

  constructor() {
    super();
  }

  trackPriceRequestClick() {
    trackPriceQuoteRequest();
  }

  render() {
    const remainingTrial = moment(this.props.user.config.exportTrialEnd).diff(moment(), 'days') + 1;
    const trialExpired = moment(this.props.user.config.exportTrialEnd).diff(moment()) < 0;
    if ((this.props.user.config.exportActivationDate || !this.props.user.config.exportTrialEnd)
      && this.props.user.config.exportEnabled) return '';
    return (
      <div className='subscribe_box'>
        {trialExpired ? (
          <span>Your trial has expired</span>
        ) : this.props.user.config.exportDeactivationDate && !this.props.user.config.exportEnabled ? (
          <span>Your subscription has ended</span>
        ) : (
          <span>
            Your trial expires in {remainingTrial} day
            {remainingTrial != 1 ? 's' : ''}
          </span>
        )}
        {this.props.user.permissions && this.props.user.permissions.manageBilling && (
          <a
            href="mailto:hello@getnave.com"
            className='btn btn-sm btn-red'
            onClick={this.trackPriceRequestClick}
            onAuxClick={this.trackPriceRequestClick}
          >
            Request Pricing Quote
          </a>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

export default connect(mapStateToProps)(SubscribeEDAddOn);
